import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { withRouter } from 'react-router-dom'
import auth from '../api/auth/hooks'
import Loader from '../Components/Common/Loader'
import ModalRoot from '../Components/Modals/ModalRoot'
import { changeLayout } from '../store/actions'
import Header from './Header'
import Sidebar from './Sidebar'

const MainLayout = (props) => {
    const dispatch = useDispatch()
    // TODO(cleanup): this selector only exists to re-dispatch the same INIT_STATE defaults
    // back into the store, which triggers the saga to set data-* HTML attributes for CSS theming.
    // Check if store/layouts could be really used or can be removed.
    const layoutType = useSelector((state) => state.Layout.layoutType)

    // Only the loading status matters here, not the data itself
    const { isPending } = auth.CurrentAgent.useQuery({ select: () => null })

    useEffect(() => {
        if (layoutType) {
            dispatch(changeLayout(layoutType))
        }
    }, [layoutType, dispatch])

    return (
        <>
            <div id="layout-wrapper">
                {isPending ? (
                    <div className="full-page-loader">
                        <Loader />
                    </div>
                ) : (
                    <>
                        <Header />
                        <Sidebar layoutType={layoutType} />
                        <div className="main-content">{props.children}</div>
                    </>
                )}
            </div>

            <ModalRoot />
        </>
    )
}

export default withRouter(MainLayout)
